export enum PreloadManagementStrategy {
    
    NO_CLEANUP = 0,
    FULL_CLEANUP = 1   

}

export enum UnloadManagementStrategy {
    NO_OP = 0,
    REMOVE_PRELOADED_RESOURCE = 1
}

export interface PartialMediaEventsConfig {
    enable: boolean,
    progress_resolution?: number,
    dynamic_viewable_impression?: boolean,
    dynamic_viewable_impression_cap?: number
}

export interface MediaEventsConfig extends PartialMediaEventsConfig{
    progress_resolution: number,
    dynamic_viewable_impression: boolean,
    dynamic_viewable_impression_cap: number
}   


export interface PlayerControlsConfig {
    events: PartialMediaEventsConfig,
    usePreferenceQuality: boolean,
}